// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper__fbr7T"};